import React, { useState } from "react";
import api from "../api/api"; // ✅ general axios client

const ForgotPasswordPage = () => { 
const [identifier, setIdentifier] = useState(""); 
const [message, setMessage] = useState(""); 
const [error, setError] = useState(""); 
const [loading, setLoading] = useState(false); 

// On the backend, if you have a PasswordController with [Route("api/[controller]")] and [HttpPost("forgot")]
// then the full URL is: POST /api/password/forgot
// here, the baseURL already contains /api, so we just write /password/forgot
const handleSubmit = async (e) => {
e.preventDefault();
setMessage("");
setError("");
setLoading(true);

try {
const response = await api.post("/password/forgot", {
identifier: identifier, // email or phone
});

setMessage(
response.data?.message ||
"Recovery email/SMS has been sent if the account exists."
);
} catch (err) {
console.error("❌ Error sending recovery email:", err);
setError( 
err?.response?.data?.message || 
err?.response?.data?.error || 
"Failed to send recovery email" 
); 
} finally { 
setLoading(false); 
} 
}; 

    return (
        <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4 py-10">
            <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl border border-slate-200 p-8">
                <h2 className="text-3xl font-bold text-center mb-6">
                    Forgot Password
                </h2>

                <form onSubmit={handleSubmit} className="space-y-5">
                    <input
                        type="text"
                        value={identifier}
                        onChange={(e) => setIdentifier(e.target.value)}
                        placeholder="Enter your email or phone"
                        className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-600"
                        required
                    />

                    <button
                        type="submit"
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-xl transition"
                        disabled={loading}
                    >
                        {loading ? "Sending..." : "Send Reset Code"}
                    </button>
                </form>

                {message && (
                    <div className="mt-5 p-3 rounded-lg bg-green-100 text-green-700 text-center">
                        {message}
                    </div>
                )}

                {error && (
                    <div className="mt-5 p-3 rounded-lg bg-red-100 text-red-700 text-center">
                        {error}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ForgotPasswordPage;